export const SGID_BACKEND_URL = 'https://vccm-sgid.onrender.com';
// export const SGID_BACKEND_URL = 'http://localhost:5001';
